"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconAttach = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconAttach = function SvgIconAttach(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.403 1.504h0a3.78 3.78 0 015.34 0 3.752 3.752 0 011.107 2.67 3.752 3.752 0 01-1.106 2.67l-4.456 4.457h0a.624.624 0 01-.885 0s0 0 0 0l.071-.07a.525.525 0 010-.743l-.07-.071L9.86 5.961l.07.07-.07-.07c.477-.478.74-1.112.74-1.787 0-.674-.263-1.308-.74-1.786h0a2.529 2.529 0 00-3.572 0L1.83 6.845s0 0 0 0a1.477 1.477 0 000 2.087 1.477 1.477 0 002.087 0l4.085-4.086s0 0 0 0a.422.422 0 000-.6l-2.6-2.742zm0 0L.947 5.961h0a2.729 2.729 0 000 3.855c.532.531 1.23.797 1.928.797.697 0 1.396-.266 1.927-.797L8.887 5.73s0 0 0 0c.316-.317.49-.738.491-1.185 0-.447-.174-.869-.49-1.185l-.072.07.071-.07a1.677 1.677 0 00-2.37 0L5.404 1.504zM3.846 6.032h0a.625.625 0 00.884.885h0l2.672-2.672-.071-.07.07.07a.426.426 0 01.602 0L3.917 6.103l-.07-.07zm0 0l2.672-2.67-2.672 2.67z",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.673 1.575a3.68 3.68 0 00-5.199 0L1.018 6.031a2.629 2.629 0 000 3.714 2.617 2.617 0 001.857.768c.672 0 1.345-.256 1.856-.768L8.816 5.66c.298-.298.462-.693.462-1.114a1.577 1.577 0 00-2.69-1.114L3.917 6.103a.525.525 0 00.743.743L7.33 4.175a.526.526 0 01.743.742L3.989 9.002a1.577 1.577 0 01-2.228 0 1.578 1.578 0 010-2.228l4.456-4.456a2.629 2.629 0 013.713 0c.497.496.77 1.155.77 1.856 0 .702-.273 1.361-.77 1.857l-4.456 4.457a.525.525 0 00.743.742l4.456-4.456a3.652 3.652 0 001.077-2.6c0-.981-.382-1.905-1.077-2.599z",
    fill: "currentColor"
  }));
};

exports.SvgIconAttach = SvgIconAttach;